









































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { AuthService } from "@/common/api";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import { namespace } from "vuex-class";
import User from "@/model/user";

const auth = namespace("Auth");
@Component({
  name: "EditPassword",
  components: {
    QErrors,
  },
})
export default class EditPassword extends Vue {
  @auth.Getter
  isAdmin!: boolean;

  @auth.Getter
  getLoggingUser: User;

  @auth.Action
  setUser!: (user) => void;

  public isShow = false;
  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public initForm = null;

  public form = {
    userId: null,
    currentPassword: "",
    newPassword: "",
  };

  public confirmPasswotrd = "";

  public option = [];

  mounted() {
    this.setInitForm();
    this.clearForm();
  }

  public setInitForm() {
    this.initForm = {
      userId: this.getLoggingUser.id,
      currentPassword: "",
      newPassword: "",
    };

    this.confirmPasswotrd = "";
  }

  public clearForm() {
    this.form = { ...this.initForm };
  }

  public show() {
    this.clearForm();
    this.errors = {};
    this.isShow = true;
  }

  async save() {
    this.errors = {};
    let result;

    if (this.form.newPassword !== this.confirmPasswotrd) {
      result = {
        status: "error",
        body: {
          message: "パスワードの変更に失敗しました",
        },
      };
      this.errors = {
        confirmPasswotrd: ["確認用のパスワードが一致しません"],
      };
    } else {
      try {
        result = await AuthService.authUpdatePassword(this.form);
        this.setInitForm();
      } catch (error) {
        result = error;
      }
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    return !compareWithKeys(this.form, this.initForm, [
      "currentPassword",
      "newPassword",
    ]);
  }
}
